import React from 'react';
import { translate } from 'react-i18next';
import { func } from 'prop-types';

import { CircleCheckIcon } from '@snapask/common-components';

import { PRODUCT_COMPARE } from '@dragonfruit/constants/premiumPage';

import styles from './ProductCompare.scss';
const cx = require('classnames/bind').bind(styles);

function ProductCompare({ t }) {
  const columns = t('premium.compare.table.columns', {
    returnObjects: true,
    defaultValue: [],
  });
  const rows = t('premium.compare.table.rows', {
    returnObjects: true,
    defaultValue: [],
  });

  const renderRow = row => (
    <div key={row.name} className={styles.row}>
      <h6 className={styles.name}>{row.name}</h6>
      {row.values.map(({ name, win }, index) => (
        <span className={styles.cell} key={`${name}${index}`}>
          <CircleCheckIcon
            width={16}
            height={16}
            className={cx(styles.icon, { win })}
          />
          {name}
        </span>
      ))}
    </div>
  );

  return (
    <section className={styles.root} id={PRODUCT_COMPARE}>
      <h3 className={styles.title}>{t('premium.compare.title')}</h3>
      <h6 className={styles.header}>
        <span />
        {columns.map((col, index) => (
          <span key={`${col}${index}`}>{col}</span>
        ))}
      </h6>
      {rows.map(renderRow)}
    </section>
  );
}

ProductCompare.propTypes = {
  t: func.isRequired,
};

export default translate(['premium'])(ProductCompare);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/ProductCompare/ProductCompare.jsx